
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 55 57","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{staticClass:"fill-primary",attrs:{"d":"M30.082 2.5C16.365 1.122 4.09 11.04 2.727 24.6c-.74 7.36 1.864 14.617 7.146 19.886l6.247-6.124a15.866 15.866 0 01-4.63-12.898c.882-8.789 8.833-15.212 17.723-14.319 8.89.893 15.405 8.77 14.521 17.56a15.783 15.783 0 01-4.196 9.251 16.389 16.389 0 01-5.715 3.938l-1.643-5.05-13.292 14.489 19.355 4.25-1.743-5.37c3.6-1.358 6.873-3.529 9.486-6.334 3.697-3.962 5.95-8.897 6.49-14.28C53.84 16.038 43.8 3.88 30.083 2.5z","fill":"#8ED4D2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(5.738 2.6 51.873)","d":"M0 0h50v52H0z"}})])])])
          )
        }
      }
    